/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateCoverage
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update coverage
 *
 */
interface IProps {
	coverageId: string;
	coveragePatchModel: Insurance.CoveragePostModel;
}
const useUpdateCoverage = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ coverageId, coveragePatchModel }) => {
			await api.FHIRCoverageApi.patchCoverage({ coverageId, coveragePatchModel });
		},
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.insurances] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateCoverage;
